import { createAppColumnHelper, Loader, Table, Tooltip } from '@libs/ui/ds'
import { withCounterModulationTranslation } from '@libs/utils/translations'
import React from 'react'

import TableHeaderColumn from '../TableHeaderColumn/TableHeaderColumn'

class TableModulation extends React.Component {
  renderWeekDate = (resumptionDate, week) => {
    // @ts-ignore migration from js(x) to ts(x)
    const { t } = this.props

    if (resumptionDate) {
      return (
        <span>
          {t('common.dates:dates.shortDate', { date: resumptionDate })}
          <Tooltip
            id='resumption'
            position='top'
            label={t('counterModulation.table.tipMessage')}
          >
            <sup>*</sup>
          </Tooltip>
        </span>
      )
    }

    return <span>{t('common.dates:dates.shortDate', { date: week })}</span>
  }

  renderCounterValue = valueInMinutes => {
    // @ts-ignore migration from js(x) to ts(x)
    const { t } = this.props

    return (
      <span>
        {Math.sign(valueInMinutes) === 1 && t('common.app:global.plus')}
        {t('common.dates:duration.minuteDecimalToHours', {
          duration: valueInMinutes
        })}
      </span>
    )
  }

  sortedEntries = () => {
    // @ts-ignore migration from js(x) to ts(x)
    const { data } = this.props

    return data?.sortBy(
      item =>
        !item ||
        (item.get('resumption_date') && !item.get('week')
          ? ''
          : item.get('week'))
    )
  }

  renderHoursOverModulation = ({ overtime_in_sec: overtimeSeconds }) => {
    // @ts-ignore migration from js(x) to ts(x)
    const { modulationPeriod, t } = this.props

    if (!modulationPeriod) {
      return (
        <span>
          {t('common.dates:duration.minuteDecimalToHours', {
            duration: 0
          })}
        </span>
      )
    }

    return (
      <span>
        {t('common.dates:duration.minuteDecimalToHours', {
          duration: overtimeSeconds || 0
        })}
      </span>
    )
  }

  getColumns = () => {
    // @ts-ignore migration from js(x) to ts(x)
    const { t, employeeDontSeeColumn } = this.props

    const columnHelper = createAppColumnHelper<any>()

    const columns = [
      columnHelper.accessor('resumption_date', {
        header: '',
        cell: ({
          row: {
            original: { resumption_date: resumptionDate, week }
          }
        }) => this.renderWeekDate(resumptionDate, week),
        meta: {
          className: 'max-w-80 text-center'
        },
        enableSorting: false
      }),
      columnHelper.display({
        id: 'id',
        header: t('counterModulation.table.cells.contractHours'),
        enableSorting: false,
        cell: ({
          row: {
            original: {
              resumption_date: resumptionDate,
              contract_time: contractTime
            }
          }
        }) => {
          if (resumptionDate) {
            return '-'
          }
          return (
            <span>
              {t('counterModulation.common.hours', { total: contractTime })}
            </span>
          )
        },
        meta: {
          className: 'w-80 text-center'
        }
      }),
      columnHelper.accessor('worked_hours', {
        header: () => (
          <TableHeaderColumn
            title={t('counterModulation.table.cells.hours')}
            titleSecondLine={t('counterModulation.table.cells.takeCare')}
            keyTooltip='hour_performed'
          />
        ),
        enableSorting: false,
        cell: ({
          row: {
            original: { worked_hours: workedHours }
          }
        }) => (
          <span>
            {t('common.dates:duration.minuteDecimalToHours', {
              duration: workedHours * 60
            })}
          </span>
        ),
        meta: {
          className: 'w-80 text-center'
        }
      }),
      columnHelper.accessor('modulation_gap', {
        header: () => (
          <TableHeaderColumn
            title={t('counterModulation.table.cells.gap')}
            keyTooltip='modulation_gap'
          />
        ),
        enableSorting: false,
        cell: ({
          row: {
            original: { value_in_minutes: valueInMinutes }
          }
        }) => this.renderCounterValue(valueInMinutes),
        meta: {
          className: 'text-center'
        }
      }),
      columnHelper.accessor('cumul', {
        header: () => (
          <TableHeaderColumn
            title={t('counterModulation.table.cells.cumulative')}
            keyTooltip='cumul'
          />
        ),
        enableSorting: false,
        cell: ({
          row: {
            original: { balance_in_minutes: valueInMinutes }
          }
        }) => this.renderCounterValue(valueInMinutes),
        meta: {
          className: 'text-center'
        }
      })
    ]
    if (employeeDontSeeColumn) {
      columns.push(
        columnHelper.accessor('overtime_hours', {
          header: () => (
            <TableHeaderColumn
              title={t('counterModulation.table.cells.workingHours')}
              keyTooltip='overtime_hours'
            />
          ),
          enableSorting: false,
          cell: ({ row: { original: entry } }) =>
            this.renderHoursOverModulation(entry),
          meta: {
            className: 'text-center'
          }
        })
      )
      columns.push(
        columnHelper.accessor('absence', {
          header: () => (
            <TableHeaderColumn
              title={t('counterModulation.table.cells.noAbsence')}
              titleSecondLine={t('counterModulation.table.cells.takeCare')}
              keyTooltip='absence'
            />
          ),
          enableSorting: false,
          cell: ({
            row: {
              original: { rest_hours: hours }
            }
          }) => (
            <span>
              {t('common.dates:duration.minuteDecimalToHours', {
                duration: hours * 60
              })}
            </span>
          ),
          meta: {
            className: 'text-center'
          }
        })
      )
    }
    return columns
  }

  render() {
    // @ts-ignore migration from js(x) to ts(x)
    const { isLoading } = this.props

    if (isLoading) {
      return <Loader.Overlay />
    }

    const columns = this.getColumns()
    const data = this.sortedEntries().toJS()

    return <Table data={data} columns={columns} />
  }
}

export default withCounterModulationTranslation()(TableModulation)
